import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { UiRepository } from '@big-direkt/state/ui';
import { UiButtonComponent } from '@big-direkt/ui/button';
import { IconBigMediumSchliessenKreis, IconComponent } from '@big-direkt/utils/icons';
import { type TopBarModel } from '@big-direkt/utils/shared';
import { translateSignal } from '@jsverse/transloco';

@Component({
    selector: 'big-ui-top-bar',
    templateUrl: './top-bar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class]': 'classList()',
    },
    imports: [IconComponent, UiButtonComponent],
})
export class TopBarComponent {
    private readonly uiRepository = inject(UiRepository);

    public readonly iconClose = IconBigMediumSchliessenKreis;

    public readonly closeMessageTranslation = translateSignal('app.topBar.closeMessage');
    public readonly classList = input('block bg-white z-(--z-top-bar) print:hidden');
    public readonly items = input<TopBarModel[]>([]);

    public closeTopBar(index: number): void {
        this.items().splice(index, 1);
        this.uiRepository.setIsTopBarShown(this.items().length > 0);
    }
}
